import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Link,
} from "@mui/material";
import { Toaster } from "../../common/alertComponets/Toaster";
import { searchGoals } from "../../service/api/emsService/GoalService"; // Use searchGoals API
import { useNavigate } from "react-router-dom";

const HrOrManagerApproval = () => {
  const [goalData, setGoalData] = useState([]);
  const [approverId, setApproverId] = useState(0); // Assuming the approverId is dynamically set
  const [employeeId, setEmployeeId] = useState(null); // Assuming employee ID will be fetched dynamically
  const navigate = useNavigate();

  // Fetch goals based on approverId (managerId) and employeeId
  useEffect(() => {
    fetchGoals();
  }, [approverId, employeeId]);

  const fetchGoals = async () => {
    const payload = {
      approverId: approverId,
      page: 0,
      size: 10,
    };

    try {
      const response = await searchGoals(payload);
      setGoalData(response?.content || []); // Update goal data
    } catch (error) {
      Toaster("error", "Error fetching goal data");
    }
  };

  // Function to render employee goal table
  const renderEmployeeGoalTable = () => {
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Employee Code</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {goalData.map((goal) => (
              <TableRow key={goal.empGoalSetupId}>
                <TableCell>{goal.employeeCode}</TableCell>
                <TableCell>{goal.fullName}</TableCell>
                <TableCell>{goal.emailId}</TableCell>
                <TableCell>
                  {/* View hyperlink with empBasicDetailId */}
                  <Link
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleViewClick(goal.empBasicDetailId);
                    }}
                    color="primary"
                    underline="hover"
                  >
                    View
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  // Function to handle the "View" click event
  const handleViewClick = (empBasicDetailId) => {
    navigate(`/home/ems/goals/employeeGoals/${empBasicDetailId}`);
  };

  return (
    <Box>
      <Typography variant="h5">Goals for Approval</Typography>
      {renderEmployeeGoalTable()}
    </Box>
  );
};

export default HrOrManagerApproval;
